module.exports = __webpack_public_path__ + "img/service_icon2.b171b833.png";